import { Container } from './style';

const SEODescriptionSkeletonLoader = () => {
  return <Container />;
};

export default SEODescriptionSkeletonLoader;
